import React from "react";

export function Jumbo(props) {
  return (
    <div className="home-jumbo">
      <div style={{ padding: "0 10px" }}>{props.children}</div>
    </div>
  );
}
